import { onMounted, ref, computed, watch } from "@vue/composition-api"
import { chartData, dashboardDetail, batchChart, chartDownload } from '../api/index';
import { fillerConfig, fitlerTableChartId, filterBatchChartItemSelector, fillterSelectList, createFilterForm, queryConditions, fillerRequestChartId } from '../filter';
import { cloneDeep } from "lodash-es";
import { handleErrorMessageToast, handleWarningMessageToast } from '@/common/util';
import {
    NewSelectorConfigType,
    NewChartListConfigType,
    ChartDataCardRecordType,
    ChartLineDataType,
    ConditionsType,
    FilterFormItemType,
    PanelsType,
    ChartsType,
    SelectorsType,
    ChartLineRecordType
} from '../types';

export function useIncomeData(props: any, content: any) {
    const maxLimit = 32;
    const dashboardData = ref();
    const newCardConfig = ref<NewSelectorConfigType | null>(null); // 重新过滤生成新的card config
    const activeArray = ref<string[]>([]); // card 的选中指标list
    const newCorePannelLineConfig = ref<NewSelectorConfigType | null>(null); // 过滤生成新的核心概览-折线图 config
    const newDetailChartsConfig = ref<NewChartListConfigType | null>(null); // 指标详情里所有chart的配置
    const cardData = ref<ChartDataCardRecordType[]>([]); // card 数据
    const corePannelLineChartData = ref<ChartLineDataType | null>(null) // 核心概览 折线图数据

    const selectList = ref<ConditionsType[]>([]); // select 类型筛选项List

    const size = 4;// 批量请求时一次最大请求图表个数
    const offset = ref(0); // 从0开始请求
    const detailTotalChartsLength = ref(0); // 详情有多少个图表
    const newDetailChartsData = ref<ChartLineDataType[]>([]); // 详情charts 是个list

    const fillterForm = ref<FilterFormItemType[]>([]); // chart的查询条件

    const tablePannel = ref<PanelsType>(); // dashboard接口里返回的table pannel配置

    const iaaTableData = ref<ChartLineDataType | null>(null) // iaa类型的 数据
    const iapTableData = ref<ChartLineDataType | null>(null) // iap类型的 数据

    const downLoading = ref(false);

    // 获取card chart data TODO: 优化，和单独折线图请求合并成一个方法，传chartId
    async function getCardChart() {
        // 参数会有一些统一的处理
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        const params =  {
            chartId: newCardConfig.value!.chartId,
            selector: newCardConfig.value!.needSelectorsfieldName,
            conditions: conditionsQuery,
            granularity: "day",
            limit: maxLimit,
            sorts: [] as [],
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                cardData.value = res.data.data.records;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }

    // 获取收入分析的所有配置项
    async function getDashboard()  {
        // // card的config信息清空
        // newCardConfig.value = null;
        try {
            const { data } = await dashboardDetail(props.tabActive);
            if(data.result === 1) {
                dashboardData.value = data.data;
                // 过滤出select 类型的筛选框
                selectList.value = fillterSelectList(data.data.conditions);
                // 生成默认的查询条件
                fillterForm.value = createFilterForm(data.data.conditions, props.appId);
                // 所有的配置项（panels维度）
                const panelsConfig = data.data.panels;
                // 核心概览pannel TODO: 先暂时用0，因为配置上顺序是固定的，不可更改的，后续看是否有其他方法
                const corePannel = panelsConfig[0]
                // 过滤出原有卡片数据
                // const oldCard = corePannel.charts.find(item => item.chartType === 'card');
                const oldCard = corePannel.charts.find((item: ChartsType) => item.chartCode === 'revenueTotalCard');
                // 根据游戏类型组合成新的card config
                newCardConfig.value = fillerConfig(oldCard!, props.gameType);

                // 根据游戏类型组合成新的核心概览-line config
                newCorePannelLineConfig.value = fillerConfig(corePannel.charts.find((item: ChartsType) => item.chartCode === 'revenueTotalLine')!, props.gameType);

                // 详情pannel
                const detailPannel = panelsConfig[1];
                // 根据游戏类型组合成新的指标详情-config 按照chartSetting 分类
                newDetailChartsConfig.value = fillerRequestChartId(detailPannel, props.gameType);
                detailTotalChartsLength.value = newDetailChartsConfig.value!.needChartIds.length;

                // 表格pannel
                tablePannel.value = panelsConfig[2];
            } else {
                handleErrorMessageToast(data.msg || data.error_msg || '系统异常');
            }

        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }

    // 获取核心数据概览折线图chart Data TODO: 与 getCardChart合并成一个方法
    async function getCorePannelLineChart() {
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        const params =  {
            chartId: newCorePannelLineConfig.value!.chartId,
            selector: newCorePannelLineConfig.value!.needSelectorsfieldName,
            // selector: ['p_date', 'dsp_pay_revenue', 'ad_show_num', 'ad_impression_num'],
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: maxLimit,
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                corePannelLineChartData.value = res.data.data;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
            // corePannelLineChartData.value = res.data;
        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }

    // 批量请求数据详情chart
    async function getBatchChart(index: number = size) {
        // 查询条件
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        if(offset.value >= detailTotalChartsLength.value) {
            return;
        }
        const dataRequests = newDetailChartsConfig.value!.chartList.slice(offset.value, index).map( (item: ChartsType) => {
            const selectors = filterBatchChartItemSelector(item)
            return {
                chartId: item.chartId,
                selector: selectors,
                conditions: conditionsQuery,
                granularity: "day",
                sorts: [] as [],
                limit: 30,
                offset: 0
            }
        });

        const params = {
            appId: props.appId,
            dataRequests: dataRequests
        }
        try {
            const res = await batchChart(params);
            if(res.data.result === 1) {
                const data = res.data.data;
                offset.value += size;
                newDetailChartsData.value = [...newDetailChartsData.value, ...data];
                // 如果offset已经超过最大条数，则直接return
                if(offset.value > detailTotalChartsLength.value) {
                    return;
                }
                // 如果最大条数-起始下标 > 4,说明还可以请求，则继续请求。size=4
                // 举个例子：第一轮[0, size), 0+size=4; 第二轮则是 [4, 4+size)
                if( detailTotalChartsLength.value - offset.value > size) {
                    getBatchChart(offset.value + size);
                } else {
                    // 否则说明不足请求size条，slice [offset， 结束下标）,可以用数组长度表示结束下标
                    getBatchChart(detailTotalChartsLength.value);
                }

            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
        } catch(error) {
            handleErrorMessageToast(error.msg || error.error_msg || '系统异常, 请稍后再试');
        }
    }

    // 获取表格chart
    async function getTableChart(gameType: string) {
        if(!tablePannel.value) return handleErrorMessageToast('未获取到相应配置');

        const chartId =  fitlerTableChartId(gameType,  tablePannel.value)
        // 当前请求的chart 相关配置
        const chartTableItem = tablePannel.value!.charts.find((item: ChartsType) => item.chartId === chartId);

        if(!chartTableItem) return handleErrorMessageToast('未获取到相应配置：chartId');
        // 需要展示的selectors
        const selectors =  chartTableItem.selectors.map((item: SelectorsType) => item.fieldName);
        // 筛选条件
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        const params =  {
            chartId: chartTableItem.chartId,
            selector: selectors,
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: maxLimit,
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                const tableData = res.data.data;
                gameType === 'iaa' ?  iaaTableData.value = tableData  :  iapTableData.value = tableData;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }

        } catch(error) {
            handleErrorMessageToast(error.error_msg || error.msg ||'系统异常，请稍后再试')
        }
    }

    // 下载表格
    async function tableDownload(tableType: string) {
        if(!tablePannel.value) {
            handleErrorMessageToast('未获取到相应配置');
            return;
        }
        downLoading.value = true;
        const chartId =  fitlerTableChartId(tableType,  tablePannel.value)
        // 当前请求的chart 相关配置
        const chartTableItem = tablePannel.value!.charts.find((item: ChartsType) => item.chartId === chartId);

        if(!chartTableItem) {
            handleErrorMessageToast('未获取到相应配置：chartId');
            return;
        }
        // 需要展示的selectors
        const selectors =  chartTableItem!.selectors.map((item: SelectorsType) => item.fieldName);
        // 筛选条件
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        const params =  {
            chartId: chartTableItem.chartId,
            selector: selectors,
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: maxLimit,
            offset: 0
        }
        try {
            const res = await chartDownload(params);
            downLoading.value = false;
            if(res.data.result === 1) {
                window.location.href = res.data.data.url;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
        } catch(error) {
            downLoading.value = false;
            handleErrorMessageToast(error.error_msg || error.msg ||'系统异常，请稍后再试')
        }
    }

    onMounted(async () => {
        // 获取dashboard,其余接口会在dashbord结果返回后触发incom-data.vue 里的watch，再请求
        await getDashboard()

    })

    return {
        activeArray,
        offset,
        iapTableData,
        iaaTableData,
        fillterForm,
        newCardConfig,
        selectList,
        cardData,
        newCorePannelLineConfig,
        corePannelLineChartData,
        dashboardData,
        newDetailChartsData,
        newDetailChartsConfig,
        tablePannel,
        downLoading,
        tableDownload,
        getCorePannelLineChart,
        getCardChart,
        getBatchChart,
        getTableChart,
        getDashboard
    }
}
